import React, { useState, useCallback } from 'react';
import '../../utils/assertions.es.js';
import { mergeRefs } from '../../utils/refs.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const useClickable = ({
  ref: htmlRef = null,
  onClick,
  shouldClickOnEnter,
  tabIndex,
  isDisabled = false,
  isFocusable = true
}) => {
  const [isButton, setIsButton] = useState(true);
  const refCallback = useCallback((node) => {
    if ((node == null ? void 0 : node.tagName) !== "BUTTON") {
      setIsButton(false);
    }
  }, []);
  const _tabIndex = isButton ? tabIndex : tabIndex || 0;
  const trulyDisabled = isDisabled && !isFocusable;
  const handleClick = React.useCallback((event) => {
    if (isDisabled) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    const self = event.currentTarget;
    isFocusable && self.focus();
    onClick == null ? void 0 : onClick(event);
  }, [isFocusable, isDisabled, onClick]);
  const handleKeyDown = React.useCallback((event) => {
    if (isDisabled || event.defaultPrevented || event.metaKey) {
      return;
    }
    const shouldClick = shouldClickOnEnter && event.key === "Enter";
    if (!isButton && shouldClick) {
      event.preventDefault();
      const self = event.currentTarget;
      self.click();
    }
  }, [isDisabled, isButton, shouldClickOnEnter]);
  const ref = mergeRefs(htmlRef, refCallback);
  const buttonAttrs = {
    type: "button",
    disabled: trulyDisabled
  };
  const nonButtonAttrs = {
    role: "button",
    tabIndex: trulyDisabled ? void 0 : _tabIndex
  };
  if (!onClick) {
    return {
      "aria-disabled": isDisabled
    };
  }
  return __spreadValues({
    ref,
    "aria-disabled": isDisabled,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, isButton ? buttonAttrs : nonButtonAttrs);
};

export { useClickable };
//# sourceMappingURL=useClickable.es.js.map
